// Delte typer for tilbud/budsjett-extraction.
// Lever på tvers av PdfOfferUpload, ImportBudgetDialog, BudgetTab osv.,
// og er identisk med output-skjemaet til extract-offer-budget-vision
// edge function (LLM Vision-basert parser).

// Alle 6 faser fra project_phase / offer_phase enum etter VIB-553/VIB-552.
// Sølvrev bruker pre/prod/post som hovedfaser, og pl/stills/reise som
// tillegg på større produksjoner (XS/S/M/L + Stills/Reise-malene).
export type ProjectPhase =
  | "pl"
  | "preprod"
  | "production"
  | "postprod"
  | "stills"
  | "reise";

export const PHASE_LABELS: Record<ProjectPhase, string> = {
  pl: "Prosjektledelse",
  preprod: "Preproduksjon",
  production: "Produksjon",
  postprod: "Postproduksjon",
  stills: "Stills",
  reise: "Reise",
};

// OvertimeSplit-type bor i src/lib/offer-calc.ts (VIB-636 dead-code cleanup:
// fjernet duplikat her som ingen importerte).

export interface BudgetLineExtracted {
  description: string;
  phase: ProjectPhase;
  quantity: number | null;
  unit: string | null;
  quantity_hours: number | null;
  amount: number;
  /** True hvis enheten er tid (t/d), false for stk/leie/musikk osv. */
  has_time: boolean;
}

export interface ExtractedBudget {
  name: string;
  /** True hvis budsjettet er et tilvalg/opsjon Vision detekterte (VIB-1021). */
  is_optional: boolean;
  lines: BudgetLineExtracted[];
  offer_total: number;
  overhead_pct: number;
  discount_pct: number;
  discount_amount: number;
  invoice_split: { startup_pct: number; final_pct: number };
  /** Avvik mellom offer_total og linjer + overhead - rabatt. 0 = parser stemmer. */
  validation_diff: number;
}
